import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { CheckboxWithLabel } from 'formik-material-ui';
import { Field } from 'formik';

import MultiOptionField from 'components/MultiOptionField';

import { IMailingRuleSubformProps } from '../../interfaces';
import { RootState } from 'store';
import { useSelector } from 'react-redux';

const SubFormExclusionsAndSelections: React.FC<IMailingRuleSubformProps> = ({
  isEditable,
}: IMailingRuleSubformProps) => {
  const {
    list: { mailingRuleOfferFilterOptions },
  } = useSelector((state: RootState) => state.parameters);
  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Typography variant="h6">Outros Filtros</Typography>
        </Grid>
        <Grid item xs={12}>
          <Field
            data-cy="sub-form-exclusions-and-selections__checkbox--exclude-exemption"
            component={CheckboxWithLabel}
            type="checkbox"
            name="excludeExemption"
            Label={{
              label:
                'Excluir Cliente/Contratos/Faturas com Isenção de Cobrança Ativa',
            }}
            disabled={!isEditable}
          />
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Typography variant="h6">Selecionar contratos</Typography>
        </Grid>
        <Grid
          data-cy="sub-form-exclusions-and-selections__check-group--active-offer"
          item
          xs={12}
        >
          <MultiOptionField
            name="activeOffer"
            options={mailingRuleOfferFilterOptions}
            direction="row"
            disabled={!isEditable}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default SubFormExclusionsAndSelections;
